import type { RoomOccupancy } from '@/domain/shared/types'
import { space, tok, tokPx } from '@sunwebgroup/ui-components'
import { Button } from '@sunwebgroup/ui-components/uds'
import { Fragment, use } from 'react'
import { styled } from 'styled-components'
import { useIntl } from '@/intl'
import { CatalogueDetailsContext } from '@/scopes/common/components/CatalogueDetailsContext'
import * as ParticipantsFilterPrimitive from '@/scopes/common/components/Filters/Participants'
import Room from '@/scopes/common/components/Filters/Participants/Room'
import { useRoomsParticipantsDistributionStore } from './useParticipantsStore'

const Content = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  padding-bottom: 0;
  min-height: 0;
  flex: 1 1 auto;
  overflow-y: auto;
`

const MAX_ROOMS = 10

export function AddRoomsButton() {
  const intl = useIntl()
  const { roomsParticipantDistribution, addRoom } = useRoomsParticipantsDistributionStore()
  const maxRoomLimitReached = roomsParticipantDistribution.length >= MAX_ROOMS
  const { isWinter } = use(CatalogueDetailsContext)
  return (
    <Button
      fullWidth
      variant="secondary"
      disabled={maxRoomLimitReached}
      onClick={addRoom}
      data-qa="add-room-button"
    >
      {intl.formatMessage({
        id: isWinter ? 'quicksearch_filter_participants_add_apartment' : 'quicksearch_filter_participants_add_room',
      })}
    </Button>
  )
}

export const Footer = styled.div`
  display: flex;
  gap: ${space('primitives_space_8')};
  background-color: ${tok('semantics_views_background_color')};
  padding: ${space('primitives_space_16')};
  border-top: ${tokPx('semantics_dividers_tickness')} solid ${tok('semantics_dividers_color')};
  flex: 0 0 auto;
`

export const DialogBannerWrapper = styled.div`
  width: 100%;
  z-index: 2;
  position: sticky;
  display: flex;
  top: 0;
  background: ${tok('semantics_views_background_color')};
  margin-bottom: 0;
  padding-top: 0;
  flex: 0 0 auto;
`

// Hardcoded for now, this should come from sitecore

function BodyComponent({ className, isMultiRoom = true }: { className?: string, isMultiRoom?: boolean }) {
  const { roomsParticipantDistribution } = useRoomsParticipantsDistributionStore()
  return (
    <Content className={className}>
      {roomsParticipantDistribution.map((_: RoomOccupancy, roomIndex: number) => (
        <Fragment key={roomIndex}>
          <Room roomIndex={roomIndex} />
        </Fragment>
      ))}
      {isMultiRoom && <ParticipantsFilterPrimitive.AddRoomsButton />}
    </Content>
  )
}

export const Body = styled(BodyComponent)``
